import React, { useState } from "react";
import { withFormik, Form } from "formik";
import * as Yup from "yup";
import { Row } from "react-bootstrap";
import ActionFormButton from "../../../../common/ActionFormButton";
import CustomInput from "../../../../common/CustomInput";
import {
  getRowItemObject,
  renderRowWithSingleItem,
  Section,
  renderSectionTitle,
  RowItem,
  Wrapper,
} from "../../../../common/FormUtils";
import { Notification } from "../../../../../types/Notification";

// Props for the NotificationForm component
type Props = {
  notification?: Notification; // Optional, for edit mode
  mode: "create" | "edit";
  handleSubmit: (notification: Notification) => void;
  isSubmitting: boolean;
};

// NotificationForm component
const NotificationForm = (props: Props): any => {
  const { notification, mode, handleSubmit, isSubmitting } = props;

  // Render the title field
  const renderTitleField = (props: any): any => {
    const titleFieldData = getRowItemObject(
      "Título",
      "Ingresa el título de la notificación",
      "text",
      "title"
    );
    return renderRowWithSingleItem(titleFieldData, props);
  };

  // Render the description field
  const renderDescriptionField = (props: any): any => {
    const descriptionFieldData = getRowItemObject(
      "Descripción",
      "Ingresa la descripción de la notificación",
      "textarea",
      "description"
    );
    return renderRowWithSingleItem(descriptionFieldData, props);
  };

  return (
    <Wrapper>
      <Form>
        <Section>
          {renderSectionTitle("Detalles de Notificación")}
          {renderTitleField(props)}
          {renderDescriptionField(props)}
        </Section>
        <ActionFormButton
          onChageFormToEditMode={() => {}}
          onClick={handleSubmit}
          canBeRemoved={false}
          disabled={isSubmitting}
          mode={mode}
        />
      </Form>
    </Wrapper>
  );
};

// Formik wrapper for NotificationForm
const NotificationFormik = withFormik({
  // Map props to form values
  mapPropsToValues: ({ notification, communityId }: any) => ({
    id: notification?.id || "",
    title: notification?.title || "",
    description: notification?.description || "",
    createdAt: notification?.createdAt || new Date().toISOString(),
    communityId: notification?.communityId || communityId,
  }),

  // Validation schema
  validationSchema: Yup.object().shape({
    title: Yup.string().required("Title is required"),
    description: Yup.string().required("Description is required"),
  }),

  // Handle form submission
  handleSubmit: (values, { setSubmitting, props }: any) => {
    console.log("Props", props);
    const { onCreateItem } = props;
    onCreateItem(values);
    setSubmitting(false);
  },
})(NotificationForm);

export default NotificationFormik;
